import { Loader } from 'lucide-react'

export default function LoadingContainer() {

  return (
    <div className='space-y-2 pb-5'>
      <div className='flex flex-start'>
        <Loader className='animate-spin'/>
        <span className='pl-2'>Patience, dear friend.</span>
      </div>
      <h2>A touch of elegance takes time...</h2>
    </div>
  );
}